export const getManagerHierarchyQuery = `
  mutation GetManagerHierarchy($userId: ID!) {
    getManagerHierarchy(userId: $userId) {
      success
      message
      data {
        id
        name
        empid
        level
      }
    }
  }
`;
